const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),

    props: {
      filterName: "supplier_name_contains",
      label: "Supplier",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "headoffice_name_contains",
      label: "Head Office",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),

    props: {
      filterName: "name_contains",
      label: "Supplier Invoice No.",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "approval_id_eq",
      label: "Batch ID",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BooleanFilter"),
    props: {
      filterName: "exported_eq",
      label: "Posted",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    props: {
      filterName: "created_at",
      label: "Created at date between",
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/finances/pi-approvals/pi-approvals-filters.js